import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gap: (p) => p.spacing(0.5),
  cursor: 'pointer',
};

export const icon: SxStyle = { cursor: 'pointer' };

export const checkbox: SxStyle = { padding: 0 };
